import { selector } from 'recoil';
import { OnlineSalesUnauthenticated } from 'gw-edge-client';
import { issuedCoverablesAndPricesAtom } from '../atoms/issuedCoverablesAndPricesAtom';
import { jobInfoAtom } from '../atoms/jobInfoAtom';
import { isLoggedOnSelector } from './isLoggedOnSelector';
import { allCoverablesAtom } from '../atoms/allCoverablesAtom';
import { onsaProductStatusListAtom } from '../atoms/onsaProductStatusListAtom';

export const pricesAndTaxesSelector = selector({
    key: 'pricesAndTaxesSelector',
    get: async ({ get }) => {
        const { jobNumber, sessionId } = get(jobInfoAtom);
        const isLoggedOn = get(isLoggedOnSelector);
        get(issuedCoverablesAndPricesAtom);
        get(onsaProductStatusListAtom);
        get(allCoverablesAtom);
        const pricesAndTaxes = await OnlineSalesUnauthenticated.getPricesAndTaxes(
            jobNumber,
            sessionId,
            !isLoggedOn
        );

        return pricesAndTaxes;
    }
});
